var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.Abierto)?_c('div',{staticClass:"sub-menu-toolbar",style:({'width': 'auto','height': _vm.Altura })},[(_vm.Modo == 'articulo-detalles')?_c('detallesarticulo',{attrs:{"Controlador":_vm.Controlador}}):_vm._e(),(_vm.Modo == 'turnero')?_c('turnero',{attrs:{"Controlador":_vm.Controlador}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }